export default {
    getCloudinaryImageUrl(imageUrl: string): string {
        return 'https://res.cloudinary.com/carfinance247-secure/image/fetch/w_750/' + imageUrl;
    }
}